import { isServerSideRender } from "@nf/helpers";
import { CellType, IMediaListModel, IMediaModel } from "@nf/common";

import { ItemPlaceholderSSR } from "./ItemPlaceholderSSR";

export type TListComponentHorizontalSSR = {
  mediaListSSR?: IMediaListModel;
  mediaList?: IMediaModel[];
  cellType?: CellType;
};

export const ListComponentHorizontalSSR = ({
  mediaListSSR,
  mediaList,
  cellType,
}: TListComponentHorizontalSSR): JSX.Element | null => {
  return mediaListSSR || mediaList ? (
    <div>
      {cellType === CellType.Promo &&
        mediaList?.map(
          (media: IMediaModel, index) =>
            isServerSideRender && (
              <ItemPlaceholderSSR key={`${media?.Id}-${index}`} media={media} />
            )
        )}
      {mediaListSSR &&
        mediaListSSR?.Entities?.map(
          (media: IMediaModel, index) =>
            isServerSideRender && (
              <ItemPlaceholderSSR key={`${media.Id}-${index}`} media={media} />
            )
        )}
    </div>
  ) : null;
};

export default ListComponentHorizontalSSR;
